import {Button} from 'platform/components';
import {Box, Heading, Text, useDevice, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {DocumentExtractionImportErrorImage} from './DocumentExtractionImportErrorImage';

interface ImportErrorProps extends RequiredTestIdProps {
  onTryAgain: VoidFunction;
}

export function DocumentExtractionImportError(props: ImportErrorProps) {
  const device = useDevice();

  const isMobile = device === 'mobile';

  return (
    <Box padding={[0, 6, 6, 6]} data-testid={props['data-testid']}>
      <VStack align="center" justify="center" spacing={4}>
        <DocumentExtractionImportErrorImage />
        <Heading size={isMobile ? 4 : 3} align="center">
          {i18n.t('entity.documentExtraction.labels.importFailed')}
        </Heading>
        <Box>
          <Text size={isMobile ? 'xSmall' : 'base'} align="center" color="secondary">
            {i18n.t('entity.documentExtraction.labels.importErrorInstruction')}
          </Text>
        </Box>
        <Button
          title={i18n.t('entity.documentExtraction.actions.tryAgain')}
          onClick={props.onTryAgain}
          data-testid={suffixTestId('actions.tryAgain', props)}
        />
      </VStack>
    </Box>
  );
}
